<template>
  <router-view/>
</template>

<script>
import QueryString from "querystring";
import * as Settings from "@/settings";
import SessionStorage from "sessionstorage";
import {APP_FAKTURA_LOGOUT_URL, SYSTEM_TERMS_FAILED_REDIRECT_URL} from "@/settings";
import {EVENT_AUTH_LOGOUT} from "@/eventbus/events";
import AuthService from "@/services/auth.service";
import {AUTH_LOGGED_IN} from "@/store/modules/auth/actions";
import _ from "underscore";

export default {
  name: "AuthorizedLayout",
  methods: {
    redirectToLogin() {
      let qs = QueryString.stringify({
        response_type: 'code',
        client_id: Settings.AccountFakturaClientId,
        redirect_uri: `${window.location.origin}`
      });

      window.location.href = `${Settings.AccountFakturaHostUrl}/Authorize?${qs}`;
    },
    onLogout() {
      SessionStorage.removeItem('auth_token');
      this.$store.commit('clearLogin');
      window.location.href = APP_FAKTURA_LOGOUT_URL;
    },
  },
  created() {
    this.$bus.$on(EVENT_AUTH_LOGOUT, this.onLogout)

    let authToken = SessionStorage.getItem("auth_token")
    let isTokenOk = !!authToken

    if (isTokenOk) {
      const authTokenObject = JSON.parse(authToken);
      const now = new Date();
      const tokenIssuedOn = new Date(authTokenObject.issued)
      const diff = now - tokenIssuedOn;
      if (diff <= 6 * 24 * 60 * 60 * 1000) {
        AuthService.getLogin(authTokenObject.access_token)
            .then(response => {
              const login = {
                username: response.data.Username,
                firstName: response.data.Firstname,
                lastName: response.data.Lastname,
                middleName: response.data.Middlename,
                company: {
                  inn: response.data.Company.Inn,
                  name: response.data.Company.Name
                }
              };

              AuthService.systemTermsCheck(authTokenObject.access_token)
                  .then(response => {
                    if (response.data) {
                      this.$store.dispatch(AUTH_LOGGED_IN, login)
                    } else {
                      window.location.href = SYSTEM_TERMS_FAILED_REDIRECT_URL
                    }
                  })
                  .catch(() => {
                    window.location.href = SYSTEM_TERMS_FAILED_REDIRECT_URL
                  })
            })
            .catch(() => {
              this.redirectToLogin()
            })

        return;
      }
    }

    this.redirectToLogin()

    /*const queryParams = {};
    _.each(window.location.search.replace('?', '')
        .split('&'), p => {
      const kv = p.split('=');
      queryParams[kv[0]] = kv[1];
    });

    // authorization code
    if (typeof (queryParams["code"]) === 'string' && queryParams["code"].length > 10) {
      AuthService.loginByAuthorizationCode(queryParams["code"])
          .then(response => {
            let token = response.data;
            token.issued = new Date().toISOString();
            SessionStorage.setItem("auth_token", JSON.stringify(token))

            window.location.href = window.location.origin + window.location.pathname
          })
          .catch(() => {
            this.redirectToLogin()
          });
    } else {
      this.redirectToLogin()
    }*/
  },
  beforeDestroy() {
    this.$bus.$off(EVENT_AUTH_LOGOUT, this.onLogout)
  }
}
</script>